import { add } from "./base";
const modeTypes = ["code", "pascal", "snake", "camel", "attribute"];
class Handler {
    settings;
    mode;
    constructor(settings, mode) {
        this.settings = settings;
        this.mode = mode;
    }
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    split(unformatted) {
        let firstAllowedSymbol;
        let previousAllowedSymbol = "";
        return unformatted
            .map((symbol, index) => {
            const newSymbol = index !== 0 &&
                symbol === symbol.toUpperCase() &&
                isNaN(+symbol) &&
                previousAllowedSymbol !== " " &&
                this.isSymbolAllowed(symbol) &&
                firstAllowedSymbol
                ? " " + symbol
                : (symbol === "_" || symbol === "-") && previousAllowedSymbol !== " "
                    ? " "
                    : (symbol === " " && previousAllowedSymbol === " ") ||
                        !this.isSymbolAllowed(symbol) ||
                        (!firstAllowedSymbol && !this.isSymbolLetter(symbol) && this.mode !== "code")
                        ? ""
                        : symbol;
            !firstAllowedSymbol && (firstAllowedSymbol = this.isSymbolLetter(symbol));
            this.isSymbolAllowed(symbol) && (previousAllowedSymbol = symbol);
            return newSymbol;
        })
            .toLower()
            .delete("-")
            .delete("_");
    }
    isSymbolLetter(symbol) {
        return (symbol >= "a" && symbol <= "z") || (symbol >= "A" && symbol <= "Z");
    }
    isSymbolAllowed(symbol) {
        return this.isSymbolLetter(symbol) || (symbol >= "0" && symbol <= "9") || symbol === " ";
    }
    partialFormat = this.format;
    format(unformatted) {
        const alignedString = this.split(unformatted);
        let result;
        switch (this.mode) {
            case "code":
                result = alignedString.delete(" ");
                break;
            case "pascal":
            case "camel":
                let previousSpace;
                result = alignedString
                    .map((symbol, index) => {
                    const newSymbol = (index === 0 && this.mode === "pascal") || previousSpace ? symbol.toUpperCase() : symbol.toLowerCase();
                    previousSpace = symbol == " ";
                    return newSymbol;
                })
                    .delete(" ");
                break;
            case "snake":
            case "attribute":
                result = alignedString.replace(" ", this.mode === "snake" ? "_" : "-");
                break;
            default:
                result = unformatted;
        }
        return { ...result, ...this.settings, type: "text", autocomplete: "on" };
    }
    unformat(formatted) {
        return formatted;
    }
    allowed(symbol, state) {
        return (this.isSymbolLetter(symbol) ||
            (symbol >= "0" && symbol <= "9" && (this.mode == "code" || state.value.length > 0)) ||
            (symbol == "_" && this.mode == "snake" && state.value.length > 0) ||
            (symbol == "-" && this.mode == "attribute" && state.value.length > 0));
    }
}
add("identifier-code", (settings) => new Handler(settings || {}, "code"));
add("identifier-pascal", (settings) => new Handler(settings || {}, "pascal"));
add("identifier-snake", (settings) => new Handler(settings || {}, "snake"));
add("identifier-camel", (settings) => new Handler(settings || {}, "camel"));
add("identifier-attribute", (settings) => new Handler(settings || {}, "attribute"));
//# sourceMappingURL=identifier.js.map